import { render, staticRenderFns } from "./subdealer_view.vue?vue&type=template&id=883f47f6&scoped=true&"
import script from "./subdealer_view.vue?vue&type=script&lang=js&"
export * from "./subdealer_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883f47f6",
  null
  
)

export default component.exports